export default {"src":"/_next/static/media/opportunities-readme-open-mobile.4169a89f.svg","height":151,"width":285,"blurWidth":0,"blurHeight":0};